import { MenuInfo } from '@@types'
import { gql, useQuery } from '@apollo/client'

type MenuQuery = {
  menu: MenuInfo
}

type MenuVariables = {
  code: string
}

export const GQL_QUERY_SINGLE_MENU = gql`
  query singleMenu($code: String!) {
    menu(code: $code) {
      id
      name
      code
      type
      is_active
      created_at
      updated_at
      menuItems {
        id
        menu_id
        internal_name
        title
        image_file_id
        icon_code
        icon_color
        text_color
        link_url
        link_type
        bold
        is_active
        sort_order
        created_at
        updated_at
        image {
          url
        }
      }
    }
  }
`

export const useFetchSingleMenu = (code: string) => {
  const { data, loading, error, refetch } = useQuery<MenuQuery, MenuVariables>(
    GQL_QUERY_SINGLE_MENU,
    {
      variables: { code },
      fetchPolicy: 'cache-and-network',
      skip: !code,
    },
  )

  return {
    menu: data?.menu,
    loading,
    error,
    refetch,
  }
}
